/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const EyeHiddenIcon = /*#__PURE__*/ createSvgIcon(
  'EyeHiddenIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.019 2.754L13.264 2 11.71 3.555c-1.058-.664-2.323-1.139-3.778-1.139-2.52 0-4.485 1.455-5.785 2.834A13.934 13.934 0 00.26 7.79a8.282 8.282 0 00-.127.231l-.007.014-.003.004v.002L0 8.28l.121.242v.002L.21 8.7l.004-.002.042.075a13.653 13.653 0 001.869 2.54c.28.3.592.603.934.893l-1.41 1.41.753.754L14.02 2.754zM1.535 8.827c-.142-.22-.253-.407-.33-.542a12.867 12.867 0 011.717-2.303c1.214-1.288 2.916-2.5 5.009-2.5 1.121 0 2.125.34 3.001.85L9.184 6.08a2.533 2.533 0 00-3.455 3.455l-1.913 1.913c-.33-.276-.635-.568-.913-.864a12.582 12.582 0 01-1.368-1.758zm4.93-.544a1.467 1.467 0 011.914-1.397L6.534 8.73a1.466 1.466 0 01-.07-.448z"
            fill="currentColor"
          />
          <path
            d="M13.292 4.802l-.141-.136-.755.755.148.141c.144.138.282.278.414.419a12.58 12.58 0 011.7 2.302 12.578 12.578 0 01-1.699 2.302c-1.206 1.285-2.908 2.498-5.028 2.498a5.746 5.746 0 01-2.45-.56l-.128-.06-.793.793.246.125a6.855 6.855 0 003.125.768c2.546 0 4.51-1.454 5.806-2.835a13.66 13.66 0 001.868-2.54 8.088 8.088 0 00.126-.232l.007-.014.002-.004.001-.002.12-.24-.12-.239-.001-.001-.088-.177-.005.003a12.21 12.21 0 00-.425-.708 13.657 13.657 0 00-1.485-1.909c-.141-.15-.29-.3-.445-.45z"
            fill="currentColor"
          />
          <path
            d="M10.425 7.837l-.067-.378-3.251 3.25.377.068a2.533 2.533 0 002.94-2.94z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.59 2.745L16.845 2l-1.974 1.974c-1.36-.875-2.99-1.505-4.87-1.505-3.172 0-5.654 1.831-7.309 3.587A17.724 17.724 0 00.294 9.284a10.483 10.483 0 00-.16.292l-.01.017-.002.005-.001.002L0 9.837l.119.238.001.003.003.005.009.017a6.112 6.112 0 00.158.292 17.361 17.361 0 002.376 3.23c.392.418.831.84 1.316 1.241l-1.82 1.82.744.745L17.59 2.745zM3.458 6.779c1.57-1.666 3.794-3.257 6.543-3.257 1.548 0 2.922.492 4.106 1.216l-2.474 2.474a3.093 3.093 0 00-4.26 4.26L4.73 14.115A13.176 13.176 0 013.434 12.9a16.305 16.305 0 01-2.226-3.026l-.02-.033.02-.035a16.67 16.67 0 012.25-3.028zm4.503 3.06a2.04 2.04 0 012.896-1.851L8.15 10.696c-.12-.26-.188-.55-.188-.857z"
            fill="currentColor"
          />
          <path
            d="M16.771 5.486l-.07-.067-.745.745.073.07c.188.179.367.36.538.544a16.307 16.307 0 012.226 3.026l.02.035-.02.036a16.307 16.307 0 01-2.226 3.026c-1.56 1.664-3.783 3.256-6.566 3.256a7.53 7.53 0 01-3.212-.734l-.063-.029-.785.785.122.062c1.154.585 2.47.97 3.938.97 3.204 0 5.687-1.831 7.335-3.59a17.36 17.36 0 002.376-3.23 10.369 10.369 0 00.158-.291l.008-.018.003-.005.001-.002L20 9.84l-.118-.236-.001-.002-.003-.005-.008-.017a8.24 8.24 0 00-.159-.292 17.357 17.357 0 00-2.376-3.23c-.178-.19-.366-.381-.564-.571z"
            fill="currentColor"
          />
          <path
            d="M13.046 9.294l-.033-.186-3.744 3.743.186.034a3.093 3.093 0 003.59-3.59z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.137 17.766l-2.136 2.136.707.707 17-17-.707-.707-2.292 2.292c-1.59-1.04-3.502-1.792-5.708-1.792-3.661 0-6.534 2.115-8.46 4.157A20.602 20.602 0 00.756 11.31a12.058 12.058 0 00-.185.337l-.01.02-.003.005-.002.003-.115.225.113.226.448-.224c-.448.224-.447.225-.447.225v.002l.004.005.01.02.037.072a17.97 17.97 0 00.71 1.198 20.176 20.176 0 002.196 2.82 16.49 16.49 0 001.626 1.522zm.711-.71c-.59-.472-1.126-.982-1.608-1.496a19.181 19.181 0 01-2.672-3.656l.055-.097A19.598 19.598 0 014.27 8.245c1.845-1.957 4.472-3.843 7.732-3.843 1.89 0 3.56.62 4.985 1.515l-3.061 3.061a3.5 3.5 0 00-4.848 4.848l-3.229 3.23zm3.957-3.958l3.392-3.391a2.5 2.5 0 00-3.392 3.392zm-9.25-1.423l.446.227-.446-.227z"
            fill="currentColor"
          />
          <path
            d="M12 20.402c-1.694 0-3.215-.443-4.55-1.12l.748-.748c1.142.534 2.412.868 3.803.868 3.3 0 5.927-1.886 7.76-3.842a19.184 19.184 0 002.673-3.658l-.055-.098a19.18 19.18 0 00-2.618-3.56c-.202-.215-.413-.429-.633-.64l.707-.707c.23.22.448.442.655.663a20.168 20.168 0 012.76 3.753 12.227 12.227 0 01.183.338l.01.02.003.005.001.002-.446.224.447.224-.002.003-.002.005-.01.02a11.953 11.953 0 01-.183.337 20.17 20.17 0 01-2.76 3.753c-1.918 2.045-4.79 4.158-8.49 4.158z"
            fill="currentColor"
          />
          <path
            d="M23.448 12.126l.112-.224-.112-.223-.447.223.447.224zM12 15.402c-.21 0-.416-.018-.616-.054l4.062-4.063A3.5 3.5 0 0112 15.402z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default EyeHiddenIcon;
